import { render, staticRenderFns } from "./CozeServiceBot.vue?vue&type=template&id=2610dd8a&scoped=true"
import script from "./CozeServiceBot.vue?vue&type=script&lang=js"
export * from "./CozeServiceBot.vue?vue&type=script&lang=js"
import style0 from "./CozeServiceBot.vue?vue&type=style&index=0&id=2610dd8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2610dd8a",
  null
  
)

export default component.exports